import { commonSortDescendingIcon, commonSortAscendingIcon } from './commonSortIcons';

export {
    commonSortAscendingIcon,
    commonSortDescendingIcon
};
